import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./../home/HomeCategory.css";
import ReactRoundedImage from "react-rounded-image";
import { getCategories } from "../../functions/category";
import laptop from "../../images/laptop.png";
import './cardsStyle.css'
import { useMediaQuery } from 'react-responsive'

const SubCategoryCard = ({ category, clicked }) => {


    const { name, images, slug } = category;

    const isMobile = useMediaQuery({ query: '(max-width: 700px' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 700px)' })



    return (
        <>
            {isTabletOrMobile ? (
                <div onClick={clicked} className="col-4 mobileCategories" style={{ padding: 2 }} >
                    <Link className="category-entity" ><div className="category-title-container">
                        <div className="title">
                            {name}
                        </div></div>
                        <div className="category-img-container">
                            <img className="category-img" src={images && images.length ? images[0].url : laptop} />
                        </div>
                    </Link>
                </div>
            ) : (
                    <li onClick={clicked} className="tile product-cell" style={{ border: 'none' }}>
                        <Link>
                            <div className="simple-tile-list_item" >
                                <div className="simple-tile_row spyglass-nav-group_wrapper" >
                                    <div tabIndex={0} role="link" className="simple-tile_box">
                                        <div className="center">
                                            <div className={isMobile ? "simple-content-tile_image-container--shrink-size" : "simple-content-tile_image-container"}><img src={images && images.length ? images[0].url : laptop} className="simple-content-tile_image" />
                                            </div>
                                        </div>
                                        <div className="category-title-container">
                                            <p style={{ color: 'black' }}>{name}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </li>
                )}

        </>
    )
}

export default SubCategoryCard
